/**
 * Gentle tidying of what someone types into the Where / When / What else fields.
 * No library — the whole thing is about twenty lines.
 *
 * 🔴 THE TRAP: naive sentence-case turns "du Pont" into "Du Pont". For THIS
 * family that is not a cosmetic slip, it is their own name spelled wrong, and
 * they would notice on day one. So the particles are protected, and any word the
 * writer capitalised themselves is left exactly alone.
 *
 * Deliberately NOT applied to comments or captions. A comment is somebody's own
 * voice; quietly rewriting it is exactly the observed-over-the-shoulder feeling
 * this section is designed to remove. Structured fields are fair game because
 * they are data. Somebody's sentence is not.
 */
const PROTECTED = ["du", "de", "des", "van", "von", "la", "le", "di", "da"];

// A short, CLOSED list of places this family names constantly. Closed on
// purpose — guessing at proper nouns in general is how you end up with
// "The Office" and "In The Spring".
const PLACES = [
  "hagley", "winterthur", "longwood", "brandywine",
  "nemours", "wilmington", "delaware", "montchanin",
];

export function tidy(raw) {
  let s = (raw || "").replace(/\s+/g, " ").trim();
  if (!s) return s;

  s = s.replace(/\bi\b/g, "I");
  s = s.replace(/(^|[.!?]\s+)([a-z])/g, (m, lead, ch) => lead + ch.toUpperCase());
  s = s.replace(/\b([a-z]+)\b/g, (w) => (PLACES.includes(w) ? w[0].toUpperCase() + w.slice(1) : w));

  // Put back any protected particle we just wrongly capitalised. Only when the
  // NEXT word is itself capitalised, so an ordinary sentence opening "Due to the
  // rain..." is untouched.
  const words = s.split(" ");
  for (let i = 0; i < words.length - 1; i += 1) {
    const lower = words[i].toLowerCase();
    if (PROTECTED.includes(lower) && /^[A-Z]/.test(words[i + 1])) words[i] = lower;
  }
  return words.join(" ");
}

export default tidy;
